export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: ["quantity", "shipped"],
  MONEY_FIELDS: ["cost", "revenue"],
  DATE_FIELDS: [],
  DATETIME_FIELDS: [],
  NON_UTC_DATETIME_FIELDS: [],
};
